var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4L8.18688 25.3757C7.48926 26.2128 7.14045 26.6314 7.13512 26.9849C7.13049 27.2922 7.26743 27.5846 7.50648 27.7778C7.78146 28 8.32632 28 9.41604 28H24L22 44L39.8131 22.6243C40.5107 21.7872 40.8595 21.3686 40.8648 21.0151C40.8694 20.7078 40.7325 20.4154 40.4935 20.2222C40.2185 20 39.6736 20 38.5839 20H24L26 4Z",
    stroke: "#3FA40F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.0c7d62515c2ce242c5e41e0fde181ff6.svg";
export { ForwardRef as ReactComponent };